import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OutlineHeartIcon = _resolveComponent("OutlineHeartIcon")!
  const _component_HeartIcon = _resolveComponent("HeartIcon")!

  return (_ctx.id && _ctx.user.enabled)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        title: "Add paper to your favorites",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
      }, [
        (!_ctx.isFavorite())
          ? (_openBlock(), _createBlock(_component_OutlineHeartIcon, {
              key: 0,
              class: "h-5 w-5 text-violet-500"
            }))
          : _createCommentVNode("", true),
        (_ctx.isFavorite())
          ? (_openBlock(), _createBlock(_component_HeartIcon, {
              key: 1,
              class: "h-5 w-5 text-violet-500"
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}